import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/UI/Button';
import Dialog from 'components/UI/Dialog';
import LoadingSpinner from 'components/UI/LoadingIndicators/LoadingSpinner';
import Skeleton from 'components/UI/Skeleton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import { saveRequestHotelRoomPictures } from 'store/dispatchers/requestHotelRooms.dispatchers';
import _ from 'lodash';

function HotelRoomPictures({
    requestRoom, storeRequestHotelRoomPictures,
})
{
    const [showManageRoomPictures, setShowManageRoomPictures] = useState(false);
    const [selectedPictures, setSelectedPictures] = useState(requestRoom.requestHotelRoomPictures?.reduce((a, v) => ({ ...a, [v.hotel_room_picture_id]: true }), {}) ?? {});
    const [selectedRoom, setSelectedRoom] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [totalPictures, setTotalPictures] = useState(requestRoom.requestHotelRoomPictures?.length ?? 0);

    const handleSaveRoomImages = () =>
    {
        const parsedPictures = _.keys(selectedPictures).map((selectedPicture) => selectedPictures[selectedPicture] ? selectedPicture : null);

        setIsLoading(true);
        storeRequestHotelRoomPictures(requestRoom.id, parsedPictures.filter((n) => n)).finally(() =>
        {
            setTotalPictures(parsedPictures.filter((n) => n).length);
            setIsLoading(false);
            setSelectedRoom(null);
            setShowManageRoomPictures(false);
        });
    };

    const toggleImage = (hotelRoomPicture) =>
    {
        setSelectedPictures({ ...selectedPictures, [hotelRoomPicture.id]: !selectedPictures[hotelRoomPicture.id] });
    };

    const handleManagePictures = (requestHotelRoom) =>
    {
        setSelectedRoom(requestHotelRoom);
    };

    useEffect(() =>
    {
        setShowManageRoomPictures(Boolean(selectedRoom));
    }, [selectedRoom]);

    useEffect(() =>
    {
        if (!showManageRoomPictures)
        {
            setSelectedRoom(null);
        }
    }, [showManageRoomPictures]);

    return requestRoom.hotelRoom?.hotelRoomPictures?.length > 0
                && (
                    <>
                        <Button onClick={() => handleManagePictures(requestRoom)}>Manage Pictures {totalPictures}/{requestRoom.hotelRoom?.hotelRoomPictures?.length}</Button>
                        <Dialog
                            model={{ value: showManageRoomPictures, setter: setShowManageRoomPictures }}
                            footer={(
                                <>
                                    <button
                                        onClick={handleSaveRoomImages}
                                        disabled={isLoading}
                                        type="button"
                                        className="tw-text-white tw-mt-3 tw-inline-flex tw-w-full tw-justify-center tw-rounded-md tw-border tw-bg-primary-default tw-px-4 tw-pt-2 tw-pb-1.5 tw-items-center tw-text-base tw-font-medium tw-shadow-sm hover:tw-bg-primary-hover focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500 focus:tw-ring-offset-2 sm:tw-mt-0 sm:tw-ml-3 sm:tw-w-auto sm:tw-text-sm"
                                    >
                                        Confirm <LoadingSpinner loading={isLoading} className="tw-ml-2 tw-mr-1" />
                                    </button>
                                    <button
                                        onClick={() =>
                                        {
                                            setShowManageRoomPictures(null);
                                        }}
                                        type="button"
                                        className="tw-mt-3 tw-inline-flex tw-w-full tw-justify-center tw-rounded-md tw-border tw-border-gray-300 tw-bg-white tw-px-4 tw-pt-2 tw-pb-1.5 tw-items-center tw-text-base tw-font-medium tw-text-gray-700 tw-shadow-sm hover:tw-bg-gray-50 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500 focus:tw-ring-offset-2 sm:tw-mt-0 sm:tw-ml-3 sm:tw-w-auto sm:tw-text-sm"
                                    >
                                        Close
                                    </button>
                                </>
                            )}
                        >
                            <div>
                                <h3 className="tw-text-lg tw-font-medium tw-leading-6 tw-text-gray-900 dark:tw-text-gray-100">
                                    Select Room Pictures
                                </h3>

                                <div className="tw-text-sm tw-mb-3">
                                    Selected Pictures will be visible on PDF
                                </div>

                                <div className="tw-grid tw-grid-cols-2 tw-gap-3 tw-max-h-[30rem] tw-overflow-y-auto">
                                    {selectedRoom?.hotelRoom?.hotelRoomPictures.map((hotelRoomPicture) => (
                                        <button type="button" onClick={() => toggleImage(hotelRoomPicture)} className={`${selectedPictures[hotelRoomPicture.id] ? 'tw-bg-primary-default' : 'dark:tw-bg-zinc-900 tw-bg-gray-500'} tw-p-3 tw-block tw-w-full tw-h-48 tw-relative`} key={hotelRoomPicture.id}>
                                            <Skeleton type="box" margin="tw-mt-0 tw-mb-0" height="tw-h-full" className="tw-absolute tw-w-full tw-h-full tw-top-0 tw-left-0 tw-z-10 tw-p-3" />
                                            <img src={hotelRoomPicture.path} alt={`Room ${hotelRoomPicture.id}`} className="tw-absolute tw-w-full tw-h-full tw-top-0 tw-left-0 tw-z-12 tw-object-cover tw-p-3" />
                                            {selectedPictures[hotelRoomPicture.id]
                                                && <FontAwesomeIcon icon={faCheckCircle} className="tw-text-white tw-bg-primary-default tw-rounded-full tw-absolute tw-z-13 tw-top-0 tw-right-0 tw-p-2" />}

                                        </button>
                                    ))}
                                </div>

                            </div>
                        </Dialog>
                    </>
                );
}

HotelRoomPictures.propTypes = {
    requestRoom: PropTypes.any,
    storeRequestHotelRoomPictures: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
    storeRequestHotelRoomPictures(requestHotelRoomId, data)
    {
        return dispatch(saveRequestHotelRoomPictures(requestHotelRoomId, data));
    },
});

export default connect(null, mapDispatchToProps)(HotelRoomPictures);
